__webpack_require__.p = "https://assets-01.periodica.press/83c3ce3-20268955749/";